export const AGNT_IR_EMAIL = 'investors@AGNTinc.com';
export const AGNT_IR_MAILTO = `mailto:${AGNT_IR_EMAIL}`;
export const AGNT_MEDIA_EMAIL = 'mediarelations@agnt.inc';
export const AGNT_MEDIA_MAILTO = `mailto:${AGNT_MEDIA_EMAIL}`;
